import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions, TdDataTableService, TdDialogService, TdDataTableSortingOrder, ITdDataTableColumn, TdLoadingService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Receiving } from '../receiving';
import { ReceivingService } from '../receiving.service';
import { Location } from '@angular/common';
import { ReceivingItem } from '../receiving-item';
import { PoService } from '../../purchasing/pos/po.service';
import { Branch } from '../../accounting/branch';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ViewChild } from '@angular/core';
import { TdFileUploadComponent } from '@covalent/core';
import { Piece } from '../../inventory/piece';
import { Product } from '../../purchasing/products/product';
import { InventoryService } from '../../inventory/inventory.service';
import { ReportService } from '../../../shared/services/report.service';
import { SupplierService } from '../../purchasing/suppliers/supplier.service';
import { BranchService } from '../../accounting/branches/branch.service';

@Component({
  selector: 'app-receiving-edit',
  templateUrl: './receiving-edit.component.html',
  styleUrls: ['./receiving-edit.component.scss'],
  providers: [ReportService]
})

export class ReceivingEditComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload: TdFileUploadComponent;

  data: Receiving;
  subscription: Subscription = new Subscription();
  currentReceiving: Receiving;

  originalReceiving: Receiving;

  allBranches$: Observable<Branch[]>

  receivingItems: ReceivingItem[];

  //data: ReceivingItem[];
  totalOrderedMetersValue: number;
  totalReceivedMetersValue: number;
  totalWeightValue: number;

  _existing_pieces: string[] = [];
  _piece_count: number = 0;

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection' },
    { name: 'designColor', label: 'Design / Color' },
    //{ name: 'grade_code', label: 'Grade' },
    { name: 'poQtyOrdered', label: 'PO QTY Ordered' },
    { name: 'pkgListPcs', label: 'Pkg List Pcs' },
    { name: 'pkgListQty', label: 'Pkg List QTY' },
    { name: 'actual_pcs', label: 'Actual PCS' },
    { name: 'actual_qty', label: 'Actual QTY' }
    //{ name: 'weight', label: 'Actual Weight (Kg)' }
  ];

  b2b_columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },
    { name: 'length', label: 'Length' },
    { name: 'weight', label: 'Weight' },
  ];
  b2b_items: Piece[] = [];

  po_item_columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection' },
    { name: 'supplier_collection', label: 'Supplier Collection' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'supplier_designColor', label: 'Supplier Design / Color' },
    { name: 'quantity', label: 'QTY' },
    //{ name: 'unit_price', label: 'Unit Price (CAD)' }
  ];
  po_items: any[] = [];

  filteredData: any[] = [];
  filteredTotal: number = 0;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;


  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _receivingService: ReceivingService,
    private _loadingService: TdLoadingService,
    private _poService: PoService,
    private _supplierService: SupplierService,
    private _branchService: BranchService,
    private _inventoryService: InventoryService,
    private _viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _reportService: ReportService,
    public _authService: AuthenticationService) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('recNumber')
        ? this._receivingService.getReceiving(params.get('recNumber'))
        : Observable.of(new Receiving()))
      .subscribe((currentReceiving: Receiving) => {
        this.currentReceiving = currentReceiving;

        this.originalReceiving = Object.assign({}, this.currentReceiving);

        // If this is NOT a new receiving (which is impossible but just in case)
        if (this.currentReceiving.po_id != null) {
          console.log(this.currentReceiving)
          // If this is an external PO receiving (supplier not null)
          if (this.currentReceiving.supplier) {
            this._poService.getPoItems(currentReceiving.po_id + '').subscribe(
              response => {
                this.po_items = response;

                this.aggregateAndCompare();
              }
            );
            // Otherwise if this is a B2B
          } else {
            this._poService.getBranchPoItems(currentReceiving.po_id + '').subscribe(
              response => {
                this.b2b_items = response;

                this.receivingItems = this.poItemsToReceivingItems(this.b2b_items);

                console.log(this.b2b_items, this.receivingItems);
              }
            );
          }
          this._loadingService.resolve('loading');
        }
      });

    this.allBranches$ = this._branchService.getBranches();
  }

  aggregateAndCompare() {
    // Whatever the case, if it is NOT in DRAFT status (i.e. a packing list was already uploaded)
    if (this.currentReceiving.status != 'DRAFT') {
      this._receivingService.getReceivingItems(this.currentReceiving.id + '').subscribe(
        response => {
          // Got them receivingItems. Get the aggregate
          this.receivingItems = response;
          this.filteredData = this.getAggregate(this.receivingItems);

          this.filteredTotal = this.filteredData.length;
        },
        error => {
          console.log('Error getting receiving items: ' + error);
          this._dialogService.openAlert({
            title: 'Error!',
            message: 'Error getting receiving items. ' + error,
            closeButton: 'OK'
          });

        }
      );
    }
  }

  poItemsToReceivingItems(b2b: Piece[]): ReceivingItem[] {
    let output: ReceivingItem[] = [];

    b2b.forEach(
      (item) => {
        console.log(item);

        output.push({
          id: '0',
          piece_no: item.piece_number,
          lot_no: item.lot_number,
          color_id: item.color_id,
          fabric_type: item.fabric_type_name,
          collection: item.collection_name,
          design: item.design_name,
          color: item.color_name,
          grade_id: item.grade_id,
          grade_code: item.grade_code,
          length: item.length,
          weight: item.weight,
          pallet_name: null,
          pallet_id: null,
          scanned_length: null,
          scanned_weight: null,
          checked: null
        });
      }
    );

    return output;
  }

  receivedStatusText() {
    let totalPieces: number = (this.receivingItems || []).length;
    let preparedPieces: number = (this.receivingItems || []).filter(p => { return p.checked }).length;
    let totalMeters: number = (this.receivingItems || []).reduce((a, b) => { return a + b.length }, 0);
    let preparedMeters: number = (this.receivingItems || []).filter(p => { return p.checked }).reduce((a, b) => { return a + b.length }, 0);

    return preparedPieces + '/' + totalPieces + ' pieces scanned, ' + parseFloat(preparedMeters.toString()).toFixed(2) + '/' + parseFloat(totalMeters.toString()).toFixed(2) + ' meters scanned';
  }

  receivedStatusValue() {
    let totalPieces: number = (this.receivingItems || []).length;
    let preparedPieces: number = (this.receivingItems || []).filter(p => { return p.checked }).length;

    return (preparedPieces / totalPieces) * 100;
  }

  markReceived() {
    // For standard (external) receivings, make sure we uploaded a packing list
    if (this.currentReceiving.supplier && this.filteredData.length == 0) {
      this._dialogService.openAlert({
        title: 'Invalid action!',
        message: 'Please upload a PACKING LIST before marking the receiving order as PACKING LIST RECEIVED',
        closeButton: 'OK'
      });
      return;
    }

    this._dialogService.openConfirm({
      title: 'Confirm!',
      message: 'Are you sure you want to confirm the current Packing List? This action cannot be undone',
    }).afterClosed().subscribe(
      result => {
        console.log(result)
        if (result) {
          this.currentReceiving.status = 'PACKING LIST';
          // Mark the receiving as PACKING LIST in all cases
          this._receivingService.updateReceiving(this.currentReceiving).subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                this._dialogService.openAlert({
                  title: 'Success!',
                  message: 'Successfully marked as PACKING LIST',
                  closeButton: 'OK'
                }).afterClosed().subscribe(
                  result => {
                    this.router.navigate(['/receiving', 'list']);
                  }
                );
              } else {
                this.currentReceiving.status = 'ORDERED';
                this._dialogService.openAlert({
                  title: 'Failed!',
                  message: 'Could not mark as PACKING LIST',
                  closeButton: 'OK'
                });
              }
            },
            error => {
              this.currentReceiving.status = 'ORDERED';
              
              this._dialogService.openAlert({
                title: 'Failed!',
                message: 'Could not mark as PACKING LIST: ' + error,
                closeButton: 'OK'
              });
            }
          );

          if (this.currentReceiving.supplier_id && Number.parseInt(this.currentReceiving.supplier_id) != 0) {
            console.log('about to map color ids');
            console.log(this.receivingItems);

            // Get the color_ids
            this.receivingItems = this.receivingItems.map(r =>
                  Object.assign(
                  { color_id: this.filteredData.find(c => 
                    { return c.collection == r.collection && c.design == r.design && c.color == r.color }
                  )['id'] }, r)
            );

            console.log('mapping color ids done');
            console.log(this.receivingItems);

            // Get the grade ids

          }

          // If this was an external PO, (supplier_id = null) the pieces are from the packing list (supplier names).
          // If this was a branch to branch (supplier_id = null), the pieces are from the PO (mystic names)
          this._receivingService.createReceivingItems(this.currentReceiving.id + '', this.receivingItems, false).subscribe(
            response => {
              console.log('Successfully created receiving items.');
            },
            error => {
              this.errorReport('Error creating receiving items.', error);
            }
          );
        }
      }
    );
  }

  changed(): boolean {
    for (let prop in this.currentReceiving) {
      if (this.currentReceiving[prop] != this.originalReceiving[prop]) {
        return true;
      }
    }

    return false;
  }

  uploadEvent(file: File) {
    this.fileUpload.cancel();

    this._existing_pieces = [];

    //this._reportService.readFile(file);

    let reader = new FileReader();
    reader.onload = () => {
      let text = reader.result;
      let wholeSet: ReceivingItem[] = [];
      // Piece #, Lot #,Fabric Type, Collection, Design, Color, Grade, Length(m), Weight(kg)

      // First run to count all valid lines
      text.split('\n').forEach(
        (line) => {
          console.log('-> ' + line);
          let parts: string[] = line.split(/[,;]{1}/);

          // Check if the format is good
          if (parts.length != 9) {
            console.log('Wrong number of columns in the CSV for this row');
            return;
          }
          // Ignore first line
          if (parts[0].toLowerCase().startsWith('piece')) return;
          // Ignore empty lines
          if (line.startsWith(',') || line.startsWith(';')) return;

          this._piece_count += 1;
        });

      //Then actually read the contents

      text.split('\n').forEach(
        (line) => {
          //console.log('-> ' + line)
          let parts: string[] = line.split(/[,;]{1}/);

          // Check if the format is good
          if (parts.length != 9) return;
          // Ignore first line
          if (parts[0].toLowerCase().startsWith('piece')) return;
          // Ignore empty lines
          if (line.startsWith(',') || line.startsWith(';')) return;

          this.reportIfDuplicated(parts[0]);

          wholeSet.push({
            id: '0',
            piece_no: parts[0],
            lot_no: parts[1],
            fabric_type: parts[2],
            collection: parts[3],
            design: parts[4],
            color: parts[5],
            grade_id: null,
            grade_code: parts[6],
            length: Number.parseFloat(parts[7]),
            weight: Number.parseFloat(parts[8]),
            //location: null,
            //location_id: null,
            pallet_name: null,
            pallet_id: null,
            scanned_length: null,
            scanned_weight: null,
            checked: null
          });
        }
      );

      this.filteredData = this.getAggregate(wholeSet);
      this.receivingItems = wholeSet;

      this.checkProducts(this.filteredData);

      this.filteredTotal = this.filteredData.length;
    }
    reader.readAsText(file);
  }

  reportIfDuplicated(piece_no: string) {
    this._inventoryService.getPieceByPieceNumber(piece_no).subscribe(
      response => {
        this._piece_count -= 1;

        if (response['id'] != 0) {
          this._existing_pieces.push(response['piece_number']);
        }

        // When we reach the end and there are dupes
        if (this._piece_count == 0 && this._existing_pieces.length > 0) {
          let len = this._existing_pieces.length;

          this._dialogService.openAlert(
            {
              title: 'Duplicated pieces!',
              // if longer than 10 only show the first 10
              message: 'The following pieces already exist in the inventory: ' +
                this._existing_pieces.slice(0, 10).join(', ') +
                (len > 10 ? '... and ' + (len - 10) + ' more' : '')
            }
          );
        }
      }
    );


  }

  selectEvent(file: File) {

  }

  cancelEvent() {

  }

  checkProducts(_pList: any[]) {
    _pList.forEach((product) => {
      // Check if the product exists
      this._receivingService.checkProduct(null, null, null, product['collection'], product['design'], product['color']).subscribe(
        response => {
          // If the product didn't exist
          if (response['id'] == 0) {
            // Alert us
            this.checkProductError(product['collection'], product['design'], product['color']);
          } else {
            product['id'] = response['id'];
            console.log('response: ' + response['id'] + ', product: ' + product['id']);
          }
        },
        error => {
          this.checkProductError(product['collection'], product['design'], product['color']);
        }
      );
    });
  }

  checkProductError(collection: string, design: string, color: string) {
    this._dialogService.openAlert({
      message: 'Product ' + collection + '/' + design + '/' + color + ' does not exist!',
      title: 'Invalid Data!',
    }).afterClosed().subscribe(
      // Then remove all items from the list
      result => {
        this.receivingItems = this.receivingItems.filter(
          i => {
            return i.collection != collection &&
              i.design != design &&
              i.color != color
          }
        );
        // And display again
        this.filteredData = this.getAggregate(this.receivingItems);
        this.filteredTotal = this.filteredData.length;
      }
    );
  }

  getAggregate(wholeSet: ReceivingItem[]) {
    let aggregate: any[] = [];

    wholeSet.forEach(
      (entry) => {

        let aggr_item: any = aggregate.find((e) => {
          return e['collection'] == entry['collection'] &&
            e['design'] == entry['design'] &&
            e['color'] == entry['color']
        });

        if (aggr_item != null) {
          aggr_item['pkg_list_pcs'] = (aggr_item['pkg_list_pcs'] * 1) + 1;
          aggr_item['pkg_list_qty'] = (aggr_item['pkg_list_qty'] * 1) + (entry['length'] * 1);

          aggr_item['actual_qty'] = Number.parseFloat(aggr_item['actual_qty']) + ((entry['scanned_length'] != 0 &&
           entry['scanned_length'] != null) ? entry['scanned_length'] : 0) * 1;

          aggr_item['actual_pcs'] = Number.parseFloat(aggr_item['actual_pcs']) + ((entry['scanned_length'] != 0 &&
           entry['scanned_length'] != null) ? 1 : 0) * 1;
        } else {
          let ordered_item: any = this.po_items.find(
            (po_item) => {
              return po_item['supplier_collection_name'] == entry['collection'] &&
                po_item['supplier_design_name'] == entry['design'] &&
                po_item['supplier_color_name'] == entry['color']
            }
          );

          aggregate.push({
            collection: entry['collection'],
            design: entry['design'],
            color: entry['color'],
            pkg_list_pcs: 1,
            pkg_list_qty: entry['length'],

            po_qty_ordered: ordered_item ? ordered_item.quantity : 0,

            actual_qty: (entry['scanned_length'] != 0 && entry['scanned_length'] != null) ? entry['scanned_length'] : 0,
            actual_pcs: (entry['scanned_length'] != 0 && entry['scanned_length'] != null) ? 1 : 0
          });
        }
      }
    );

    return aggregate;
  }

  getMinDate(): string {
    let today: Date = new Date();
    let minDate: Date = new Date();

    if (today.getDate() <= 5) {
      minDate.setMonth(today.getMonth() - 1);
    }

    minDate.setDate(1);

    return minDate.toISOString().substr(0, 10);
  }

  updateOrder() {
    this._loadingService.register('loading');

    this._receivingService.updateReceiving(this.currentReceiving).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {

          this.originalReceiving = Object.assign({}, this.currentReceiving);

          this._dialogService.openAlert({
            message: 'Receiving Order ' + this.currentReceiving.receiving_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/receiving', 'list']);
          });
        } else {
          this.errorReport('Could not update Receiving Order ' + this.currentReceiving.receiving_number, response);
        }
        this._loadingService.resolve('loading');
      },
      error => {
        this.errorReport('Error updating Purchase Order ' + this.currentReceiving.receiving_number, error);
        this._loadingService.resolve('loading');
      },
      () => { }
    );

    // If this was an external PO, (supplier_id != 0), allow to save packing list items on update even if we don't set it to PACKING LIST
    if (this.currentReceiving.supplier_id && Number.parseInt(this.currentReceiving.supplier_id) != 0) {
      // Get the color_ids
      this.receivingItems = this.receivingItems.map(
        r => Object.assign(r, { color_id: this.filteredData.find(
          c => { return c.collection == r.collection && c.design == r.design && c.color == r.color })['id'] }));
      // Then save
      this._receivingService.createReceivingItems(this.currentReceiving.id + '', this.receivingItems, false).subscribe(
        response => {
          console.log('created receiving items successfully');
        },
        error => {
          this.errorReport('Error creating receiving items', error);
        }
      );
    }
  }

  getMaxDate(): string {
    let today: Date = new Date();
    let maxDate: Date = new Date(today.getFullYear(), today.getMonth() + 2, 1);

    return maxDate.toISOString().substr(0, 10);
  }

  withinRange(targetDate: string, minDate: string, maxDate: string) {
    return (new Date(targetDate) >= new Date(minDate) && new Date(targetDate) <= new Date(maxDate));
  }

  total(data: any[], field: string) {
    return data.reduce(function (a, b) { return (Number.parseFloat(a) || 0) + (Number.parseFloat(b[field]) || 0) }, 0);
  }

  getTotalMeters(): number {
    let t: number = 0;
    this.po_items.forEach(
      function (item) {
        t += item.quantity * 1; //The * 1 is to turn the string to number
      }
    );
    return t;
  }

  getTotalValue(): number {
    let t: number = 0;
    this.po_items.forEach(
      function (item) {
        t += item.quantity * item.unit_price;
      }
    );
    return t;
  }

  mismatchReport() {
    this._reportService.receivingMismatchReport(this.currentReceiving, this.filteredData);
  }

  isOrdered() {
    return this.currentReceiving != null && (this.currentReceiving.status == 'ORDERED' || this.currentReceiving.status == 'PACKING LIST' || this.currentReceiving.status == 'RECEIVED');
  }

  isPackingList() {
    return this.currentReceiving != null && (this.currentReceiving.status == 'RECEIVED' || this.currentReceiving.status == 'PACKING LIST');
  }

  isReceived() {
    return this.currentReceiving != null && this.currentReceiving.status == 'RECEIVED';
  }

  goBack(): void {
    this.location.back();
  }

  errorReport(message: string, error: any) {
    console.log(message + ' ' + error);

    this._dialogService.openAlert({
      title: 'Error!',
      message: message + error,
      closeButton: 'OK'
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/receiving/receiving-edit/receiving-edit.component.ts